import React, { useEffect, useState } from "react";
import AdayProfil from "./AdayProfil";
import PersonelProfil from "./PersonelProfil";
import {useCareerLanguage} from '../career/CareerLanguage';

const Profil = ({section='profile'}) => {
  const {t}=useCareerLanguage();
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const rol = localStorage.getItem("userRole");
    setUserRole(rol);
  }, []);

  if (userRole === null) return <p>{t('loading')}</p>;

  return userRole === "personel" ? <PersonelProfil /> : <AdayProfil view={section} />;
};

export default Profil;
